var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v(" Step 8 of 9: Personal Considerations "),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Cultural/Religious Practices "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "personal_cultural_practice",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("personal_cultural_practice", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_cultural_practice,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "personal_cultural_practice",
                          $$v
                        )
                      },
                      expression: "localFormData.personal_cultural_practice",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Hobbies/Interests "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "personal_hobbies",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("personal_hobbies", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_hobbies,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "personal_hobbies", $$v)
                      },
                      expression: "localFormData.personal_hobbies",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Social Connections "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "personal_social",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("personal_social", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_social,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "personal_social", $$v)
                      },
                      expression: "localFormData.personal_social",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "personal_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("personal_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.personal_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "personal_notes", $$v)
                      },
                      expression: "localFormData.personal_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }